module.exports = angular.module('cartographer.common.serialize', [])

_ = require 'underscore'

module.exports.factory 'crtSerialize', $DI (crtLog, crtDatetime, crtLocation) ->

  # Transform JSON from API responses / cookie storage to enrich it for use in the client application:
  #
  # serializableObject -> usefulObject
  decode = (obj) ->
    if crtDatetime.isDatetimeJson(obj)
      crtDatetime.decodeDatetimeJson(obj)
    else if _.isArray(obj)
      ans = []
      for value in obj
        ans.push(decode(value))
      ans
    else if _.isObject(obj)
      if obj._type?
        crtLog.error("crtSerialize found _type field", obj)
      ans = {}
      for key, value of obj
        ans[key] = decode(value)
      ans
    else
      obj

  # Transform an object to make it safe for serializing to JSON and sending to the API / cookies:
  #
  # usefulObject -> serializableObject
  encode = (obj) ->
    if crtDatetime.isDatetime(obj)
      crtDatetime.encodeDatetimeJson(obj)
    else if _.isArray(obj)
      ans = []
      for value in obj
        ans.push(encode(value))
      ans
    else if _.isObject(obj)
      ans = {}
      for key, value of obj
        ans[key] = encode(value)
      ans
    else
      obj

  return {
    decode
    encode
  }
